var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('power-bi',{attrs:{"code":"eyJrIjoiNzZjZWQ0ODQtNmVlZS00ZTgwLWEwNWMtM2Q3ZTk5YTg0NmY0IiwidCI6ImM4NDJjMWQ5LWQzNjQtNDcxNi1iN2UzLWNhNDgxYTIzZDZhYyJ9"}})}
var staticRenderFns = []

export { render, staticRenderFns }